package com.yendo.mx.ui.profile

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Logout
import androidx.compose.material.icons.filled.Restore
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.yendo.mx.ui.theme.RosaYendo

@Composable
fun CuentaEnRecuperacionScreen(onRestaurar: () -> Unit, onCerrarSesion: () -> Unit) {
    val isDark = isSystemInDarkTheme()
    val colorFondoGlobal = if (isDark) Color(0xFF121212) else Color(0xFFF8F8F8)
    val colorTextoPrincipal = if (isDark) Color.White else Color.Black
    val colorTextoSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray
    
    var procesando by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier.fillMaxSize().background(colorFondoGlobal).padding(24.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Icon(Icons.Default.Restore, contentDescription = "Restaurar", tint = RosaYendo, modifier = Modifier.size(80.dp))
            Spacer(modifier = Modifier.height(24.dp))
            
            Text("¡Qué bueno verte de nuevo!", fontWeight = FontWeight.ExtraBold, fontSize = 26.sp, color = colorTextoPrincipal, textAlign = TextAlign.Center)
            Spacer(modifier = Modifier.height(16.dp))
            
            Text("Solicitaste eliminar esta cuenta recientemente. Si deseas continuar usando Yendo Mx, podemos cancelar la solicitud y restaurar todos tus datos al instante.", textAlign = TextAlign.Center, color = colorTextoSecundario, fontSize = 15.sp, lineHeight = 22.sp)
            Spacer(modifier = Modifier.height(40.dp))

            Button(
                enabled = !procesando,
                onClick = {
                    procesando = true
                    onRestaurar()
                },
                modifier = Modifier.fillMaxWidth().height(52.dp), colors = ButtonDefaults.buttonColors(containerColor = RosaYendo), shape = RoundedCornerShape(12.dp)
            ) {
                if (procesando) {
                    CircularProgressIndicator(modifier = Modifier.size(24.dp), color = Color.White)
                } else {
                    Text("Restaurar mi cuenta", color = Color.White, fontWeight = FontWeight.Bold, fontSize = 16.sp)
                }
            }

            Spacer(modifier = Modifier.height(16.dp))

            OutlinedButton(
                enabled = !procesando,
                onClick = {
                    procesando = true
                    onCerrarSesion()
                },
                modifier = Modifier.fillMaxWidth().height(52.dp), shape = RoundedCornerShape(12.dp), border = androidx.compose.foundation.BorderStroke(1.dp, colorTextoSecundario)
            ) {
                Icon(Icons.AutoMirrored.Filled.Logout, null, tint = colorTextoPrincipal, modifier = Modifier.size(20.dp))
                Spacer(Modifier.width(12.dp))
                Text("Mantener desactivada", color = colorTextoPrincipal, fontWeight = FontWeight.Bold, fontSize = 16.sp)
            }
        }
    }
}
